import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import {
  Building2,
  Shield,
  Scale,
  Calculator,
  Receipt,
  Users,
  Globe,
  Lock,
  FileCheck,
  Award,
  DollarSign,
  UserCheck,
} from "lucide-react";

const domains = [
  {
    icon: <Building2 className="w-8 h-8 text-primary" />,
    title: "Company Formation",
    description:
      "Help users register their business, obtain an EIN, and get licensed with step-by-step guidance.",
    link: "/company-formation",
  },
  {
    icon: <Shield className="w-8 h-8 text-primary" />,
    title: "Business Insurance",
    description:
      "Simplify coverage with guided recommendations, policy comparison, and compliance for GovCon.",
    link: "/business-insurance",
  },
  {
    icon: <Scale className="w-8 h-8 text-primary" />,
    title: "Legal",
    description:
      "Offer affordable templates, contracts, trademark support, and access to legal experts.",
    link: "/legal-services",
  },
  {
    icon: <Calculator className="w-8 h-8 text-primary" />,
    title: "Bookkeeping",
    description:
      "Provide seamless accounting, reconciliation, and payroll setup for accurate financials.",
    link: "/bookkeeping",
  },
  {
    icon: <Receipt className="w-8 h-8 text-primary" />,
    title: "Tax",
    description:
      "Manage federal and state filings, quarterly payments, and maximize deductions.",
    link: "/tax-services",
  },
  {
    icon: <Users className="w-8 h-8 text-primary" />,
    title: "Human Resources (HR)",
    description:
      "Handle onboarding, benefits, payroll, and employee compliance in one place.",
    link: "/human-resources",
  },
  {
    icon: <Globe className="w-8 h-8 text-primary" />,
    title: "Website Development",
    description:
      "Build professional websites at low cost to establish online presence and credibility.",
    link: "/website-development",
  },
  {
    icon: <Lock className="w-8 h-8 text-primary" />,
    title: "Cybersecurity",
    description:
      "Protect data and meet compliance with SOC 2, CMMC, and security best practices.",
    link: "/cybersecurity",
  },
  {
    icon: <FileCheck className="w-8 h-8 text-primary" />,
    title: "Government Contracting",
    description:
      "Assist with SAM registration, DCAA compliance, proposal prep, and certifications.",
    link: "/government-contracting",
  },
  {
    icon: <Award className="w-8 h-8 text-primary" />,
    title: "Compliance & Certifications",
    description:
      "Guide users through required standards such as SOC 2, ISO, OSHA, and HIPAA.",
    link: "/compliance-certifications",
  },
  {
    icon: <DollarSign className="w-8 h-8 text-primary" />,
    title: "Funding & Grants",
    description:
      "Help identify grants, SBIR/STTR opportunities, loans, and prepare funding applications.",
    link: "/funding-grants",
  },
  {
    icon: <UserCheck className="w-8 h-8 text-primary" />,
    title: "All Experts",
    description:
      "Give users access to a trusted network of accountants, attorneys, HR specialists, and advisors.",
    link: "/all-experts",
  },
];

const BizServePortalDomains = () => {
  return (
    <section className="py-16 px-4 bg-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Complete Business Solutions
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Everything you need to start, run, and grow your business, all in
            one integrated platform.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {domains.map((domain, index) => (
            <Card
              key={index}
              className="border hover:shadow-lg transition-shadow"
            >
              <CardHeader>
                <div className="mb-4">{domain.icon}</div>
                <CardTitle className="text-xl">{domain.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground mb-4">
                  {domain.description}
                </p>
                <Button variant="outline" className="w-full">
                  Learn More
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BizServePortalDomains;
